import React from 'react';


const ScriptEmbed = ({src, scriptId, type='text/javascript', async = false, defer = false, charSet = ''}) => {
  const parentElement = React.useRef(null);

  React.useEffect(() => {
    if(!window) return;
    
    if(parentElement.current) {
      const script = window.document.createElement('script');
      script.src = src;
      script.id = scriptId;
      script.async = async;
      script.defer = defer;
      script.charSet = charSet;
      script.type = type;
      parentElement.current.appendChild(script);
    }

    return(() => {
      if(!window) return;

      if(parentElement.current) { 
        parentElement.current.removeChild(window.document.getElementById(scriptId));
      }
    })

  })

  return (
    <div ref={parentElement} />
  )
}

export default ScriptEmbed;